import { render } from "./PointGrantResult.vue?vue&type=template&id=4d408d46&scoped=true&ts=true"
import script from "./PointGrantResult.vue?vue&type=script&lang=ts"
export * from "./PointGrantResult.vue?vue&type=script&lang=ts"

import "./PointGrantResult.vue?vue&type=style&index=0&id=4d408d46&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d408d46"]])

export default __exports__